export interface DiscoveredUrl {
  _id?: string;
  integrationId: string;
  url: string;
  foundOnUrl: string | null;
  numberOfURLsDiscovered: number,
  depth: number;
  status: DiscoveredUrlStatus;
  errorMessage?: DiscoveredUrlError;
  // left out of the capture by the user
  excluded?: boolean;
  // links found on the page when it was explored; absent if it was not explored or could not be read
  linksFound?: number;
  createdAt?: string;
  updatedAt?: string;
}

export enum DiscoveredUrlStatus {
  UNKNOWN = 'UNKNOWN', // initial state
  DONE = 'DONE', // page was explored, and backlinks extracted
  ERROR = 'ERROR', // could not load page, or something unexpected occurred while exploring
}

export enum DiscoveredUrlError {
  UNABLE_TO_NAVIGATE_TO_URL = 'UNABLE_TO_NAVIGATE_TO_URL',
  UNABLE_TO_EXTRACT_LINKS = 'UNABLE_TO_EXTRACT_LINKS',
}

export type DiscoveredUrlsFilters = {
  query?: string,
  depth?: string,
};

export interface DiscoveredUrlsByDepthData {
  depth: number;
  count: number;
}
